import Vue from "vue";
import router from '@/router/index';
import {
  GetCurrentStepURL,
  AnswerStepURL,
  GoStepBackURL,
} from "@/utils/apiUrls";

export default {
  namespaced: true,

  state: {
    selectedUserflow: null,
    userflowData: null,
    isUserflowLoading: true,
    currentStep: null,
    progress: 0,
    quizAnswers: [],
    canUndo: false,
  },

  getters: {
    canGoNext(state) {
      return (
        state.quizAnswers.filter((qa) => qa === null || qa === "").length == 0
      );
    },
  },

  mutations: {
    addLoop(state) {
      state.quizAnswers = [
        ...state.quizAnswers,
        ...new Array(state.currentStep.question.answer_blocks.length).fill(
          null
        ),
      ];
    },

    changeQuizAnswer(state, payload) {
      Vue.set(state.quizAnswers, payload.index, payload.value);
    },

    setUserflowLoading(state, payload) {
      state.isUserflowLoading = payload;
    },

    setCanUndo(state, payload) {
      state.canUndo = payload;
    },

    updateSelectedUserflow(state, payload) {
      state.selectedUserflow = payload.userflow;
    },

    updateCurrentStep(state, payload) {
      state.currentStep = payload.step;
      if (payload.step !== null)
        state.quizAnswers = new Array(
          payload.step.question.answer_blocks.length
        ).fill(null);
    },

    updateProgress(state, payload) {
      state.progress = payload.progress;
    },
  },

  actions: {
    async goStepBack({ state, commit }) {
      commit("setUserflowLoading", true);
      await Vue.axios
        .get(GoStepBackURL(state.selectedUserflow.ID))
        .then((resp) => {
          commit("updateCurrentStep", { step: resp.data.step });
          commit("updateProgress", { progress: resp.data.progress });
          commit("setCanUndo", resp.data.has_history);
          commit("setUserflowLoading", false);
        });
    },

    async answerStep({ state, commit, rootGetters, dispatch, rootState }) {
      commit("setUserflowLoading", true);
      await Vue.axios
        .post(AnswerStepURL(state.selectedUserflow.ID), {
          answer_blocks: state.quizAnswers.map((ans) => ({ answer: ans })),
          case_id: rootGetters["cases/currentUsercase"]?.ID,
        })
        .then((resp) => {
          if (resp.data.is_passed) {
            if (rootState.route.path === "/") {
              router.push("/cases")
            }
            if (Vue.auth.user().role === 'candidate') {
              router.push("/profile")
            }
            commit("updateSelectedUserflow", { userflow: null });
            commit("updateCurrentStep", { step: null });
            commit("updateProgress", { progress: 0 });
            dispatch("flows/refreshFlowsList", null, { root: true });
            dispatch("usercase/refreshUsercaseList", null, { root: true });
            if (rootState.route.meta.tab === "overview") {
              dispatch("usercase/sponsorship/refreshOverview", null, {
                root: true,
              });
            }
          } else {
            commit("updateCurrentStep", { step: resp.data.step });
            commit("updateProgress", { progress: resp.data.progress });
          }
          commit("setUserflowLoading", false);
          commit("setCanUndo", resp.data.has_history);
        })
        .catch((/* e */) => {
          // console.log(e);
        });
    },

    selectUserflowForQuiz({ commit, dispatch }, payload) {
      commit("updateSelectedUserflow", payload);
      dispatch("getStepForQuiz");
    },

    async getStepForQuiz({ commit, state }) {
      commit("setUserflowLoading", true);
      await Vue.axios
        .get(GetCurrentStepURL(state.selectedUserflow.ID))
        .then((resp) => {
          commit("updateCurrentStep", { step: resp.data.step });
          commit("updateProgress", { progress: resp.data.progress });
          commit("setCanUndo", resp.data.has_history);
          commit("setUserflowLoading", false);
        });
    },
  },
};
